// Maps an unknown thrown value (typically a tRPC client error) to a
// short, user-facing message. We detect the tRPC error code
// defensively — checking the structured `data.code` first, then the
// message string — so we never import server types and never render a
// raw code like "UNAUTHORIZED" to a paying user.
export function friendlyTrpcError(err: unknown): string {
  const code = (err as { data?: { code?: string } })?.data?.code;
  const message =
    err instanceof Error
      ? err.message
      : typeof err === "string"
        ? err
        : "";
  const matches = (c: string): boolean =>
    code === c || message.includes(c);

  if (matches("UNAUTHORIZED")) {
    return "Your session expired — please sign in again.";
  }
  if (matches("FORBIDDEN")) {
    return "You don't have access to that.";
  }
  return "Something went wrong. Please try again.";
}
